import { CardActionsProps } from "@mui/material"
import { CardActions, styled } from "@tm/components"
import { classes } from "@tm/utils"
import { forwardRef } from "react"
import { offerItemClasses, offerItemName, offerItemSlots } from "@tm/themes"

const OfferItemThumbnailComponent = forwardRef<HTMLDivElement, CardActionsProps>((props, ref) => (
    <CardActions {...props} className={classes(offerItemClasses.thumbnail, props.className)} ref={ref} />
))
export const OfferItemThumbnail = styled(OfferItemThumbnailComponent, {
    name: offerItemName,
    slot: offerItemSlots.thumbnail,
    overridesResolver: (_, styles) => styles.thumbnail,
})({
    height: "6em",
    minWidth: "6em",
    display: "flex",
    alignItems: "center",
    justifySelf: "center",
    justifyContent: "center",
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 1px 4px",
    "> svg": {
        height: "100%",
    },
})
